import { computed, isRef } from '@vue/composition-api';

export default function useBookingStationTimesWithoutRemoved (booking) {
  const bookingStationTimesWithoutRemoved = computed(() => {
    const unwrappedBooking = (isRef(booking)) ? booking.value : booking;

    return unwrappedBooking.bookingStationTimes.filter(bookingStationTime => !bookingStationTime._removed);
  });

  return {
    bookingStationTimesWithoutRemoved,
  };
}
